import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom"; // For dynamic routing
import { auth } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";

const Layout = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="layout-container">
      {isAuthenticated && <Sidebar />} {/* Only show sidebar if authenticated */}
      <div className="content">
        <Outlet /> {/* Content of each page will be rendered here */}
      </div>
    </div>
  );
};

export default Layout;
